import 'stylesheets/brands_deferred.css';
import 'common';
import 'components/hamburger_mobile_menu';
import {onFirstScroll} from 'components/on_first_scroll';

onFirstScroll('friendReferrals', () => {
  import(/* webpackChunkName: "AccordionComponent" */ 'components/accordion').then(module =>
    new module.AccordionComponent().mount(),
  );
});

let addressInitialized = false;

const initAddressForm = function (event) {
  if (addressInitialized) {
    return true;
  }

  event.preventDefault();

  import(/* webpackChunkName: "AddressSearchForm" */ 'address_search_form').then(module => {
    import(/* webpackChunkName: "multipleAddressMatcher" */ 'brands/multiple_address_matcher').then(
      ({multipleAddressMatcher}) => {
        addressInitialized = true;

        new module.AddressSearchForm({onSubmitting: multipleAddressMatcher}).mount();
        event.target.dispatchEvent(event);
      },
    );
  });
};

const initLiberty = function () {
  import(/* webpackChunkName: "Liberty" */ 'liberty').then(module => new module.Liberty().mount());
};

const addressFormInputs = document.querySelectorAll(".search-form--form input[type='text']");
addressFormInputs.forEach(el => el.addEventListener('focus', initAddressForm));

// if the clear address button is clicked before the input is focused, call initAddressForm to ensure the clear button works
document
  .querySelectorAll('.address_string_clear')
  .forEach(el => el.addEventListener('click', initAddressForm));

document.body.addEventListener('click', initLiberty);
document.body.addEventListener('scroll', initLiberty);

import(/* webpackChunkName: "dateTimeFieldsPickers" */ 'date_time_fields_pickers').then(module =>
  module.dateTimeFieldsPickers(),
);

import(/* webpackChunkName: "transcend" */ 'transcend').then(module =>
  module.setupTranscendClick(),
);

if (document.getElementById('promo_auto_applied_banner')) {
  import(/* webpackChunkName: "promoAutoAppliedManager" */ 'promo_auto_applied_manager').then(
    module => {
      module.promoAutoAppliedManager();
    },
  );
}

import(/* webpackChunkName: "preciseLocation" */ '../precise_location').then(module => {
  const perciseLocationButton = document.getElementById('use-precise-location');
  if (perciseLocationButton) {
    perciseLocationButton.addEventListener('click', module.fetchAndFillPreciseLocation);
  }
});
